// extracted by mini-css-extract-plugin
module.exports = {"name":"formatters_name__1WfOG","name__link":"formatters_name__link__396Oo","name__link__name":"formatters_name__link__name__3V1nc","name__red":"formatters_name__red__14MtR"};